import { Outlet, createFileRoute } from '@tanstack/react-router';

import { PublicLayout } from '@/components/Public/PublicLayout';

export const Route = createFileRoute('/_public')({
  component: PublicPageLayout,
});

function PublicPageLayout() {
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
}
